export default "__VITE_ASSET__D_jtvLr7__"